export default __webpack_public_path__ + "static/media/DaciaBlock-Light.f20efe7b.eot";